import { Injectable } from '@angular/core';
import { LookupDomain, LookupValueItem } from '../interfaces/lookup.interface';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { formatUrl } from '../shared/utils/format-url-util';
import { HttpRequestService } from '../shared/services/http-request.service';
import { UserService } from './user.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private lookupValues: any = null;
  private tasLookupValues: any = null;
  private providerTypeLookupValues: any = null;

  constructor(private http: HttpRequestService, private userService: UserService) { }

  fetchLookupValues() {
    const program = this.userService.getSelectedProgram();
    const program_code = program?.program_code;

    const payload = {
      "programCode": program_code,
      "payloadData": {
        "lkpdomainname":
          ["STATE", "Gender", "Address_Type", "Contact_Type", "Special_Accomdation", "Language", "Identifier_type", "Communication_Type", "Lead_Application_Status",
            "Lead_Application_Stage",
            "Lead_Reason_for_Denial",
            "Lead_Reason_for_Approval",
            "Participant_Enrollment_status",
            "Lead_Application_Source",
            "License_Type",
            "License_Type_Referral",
            "License_Type_IP", "License_Type_IC", "License_Type_Auth", "License_Type_Vendor", "License_Type_IP_IC", "Upload_Doc_Type", "License_Type_Employer", "License_Type_IF", "License_Type_AR",
            "Service_Type", "Service_Type_IP", "Service_Type_IC", "Service_Type_Vendor", "Service_Type_IP_IC",
            "service_details",
            "Waiver",
            "Participant_Register_Mode",
            "ProviderType",
            "Relationship",
            "Race",
            "Eye Color",
            "Hair Color",
            "Tax Exemption",
            "enr_status_reason",
            "process_code_cat",
            "Yes_No",
            "TS_DIS",
            'Rate_Type', 'Medicaid_Billing_Code', 'Service_Group', 'Increment_Units', 'Measurement_Units', 'County', 'City',
            'LDSS_Office',
            'CFI',
            'Utype',
            'AuthS',
            'ConsType',
            'CBAType',
            'AFT',
            'Business Status',
            'Manual Entry reason',
            'TS_App_S',
            'Invoice_Business_Status',
            'Invoice_Processing_Status',
            'Disposition Reason',
            'TimeSheet Disposition',
            'contact_status_reason_lkp',
            'claim_status_lkp',
            'timesheet_filter_serviceCode',
            'invoice_filter_serviceCode',
            'consumer_ts_denial',
            'Deny Reason',
            'consumer_invoice_denial',
            'invoice_denial_reasons',
            'adjustment_reason', 'Timesheet_Adjustment_Reason',
            'resurrect_reason',
            'FAC_FA',
            'FAC_SPA',
            'program_code',
            'Referral_Source',
            'auth_type',
            'service_location',
            'purchaseRequest_filter_serviceCode',
            'purchasereq_rejected_reason',
            'ENR_COV_Gaps',
            'prv_enr_association_status',
            'ar_enr_association_status',
            'Disassociation Reason',
            'Employment_Tasks',
            'Mass Adjustment Type',
            'Mass Adjustment Status',
            'Mass Adjustment Critieria',
            'Mass Adjustment Process Type',
            'Fms Model',
            'Participant-Disenroll-Reason',
            'Reason_Adjustment',
            'Conservatorship_Type',
            'file_triage_role_type',
            'license_type_file_triage',
            'Invoice_Upload_Doc_Type',
            'Relation_Parent',
            'Timesheet_Payroll_Batch_Criteria',
            'Timesheet_Payroll_Batch_Operator',
            'Payroll_Batch_Type',
            'Payroll_Data_type'
          ]
      }
    }
    // return this.http.post<any>("http://localhost:8080/api/v1/getLookupValues", payload);
    return this.http.post(ENDPOINTS.GET_LOOKUP_VALUES, payload);

    //pending API changes, make this http.post<ApiResponse<LookupDomain>>
  };

  getLookupValue(key: string): LookupValueItem[] {
    let lookupValues: LookupValueItem[] = [];
    const lookupResponse = this.lookupValues;
    const lookupDomains = lookupResponse?.responsedata ?? [] as LookupDomain[];
    const targetDomain = lookupDomains.find((value: LookupDomain) => value.lkpDomainName === key);

    if (targetDomain) {
      lookupValues = [...targetDomain.lookupValue];
    }

    // Make changes for Communication_Type lookup values, as per new requirement.
    if (key === 'Communication_Type') {
      lookupValues.forEach(lk => {
        if (lk.lkpValueCode === 'mobile') {
          lk.lkpValueName = 'Text';
        }

        if (lk.lkpValueCode === 'altPhone') {
          lk.lkpValueName = 'Telephone';
        }
      });
    }

    if (key === 'Identifier_type') {
      const cinType = lookupValues.find(lv => lv.lkpValueCode === 'CIN');
      if (cinType != null) {
        cinType.lkpValueName = 'UCI ID';
      }

      const ssnType = lookupValues.find(lv => lv.lkpValueCode === 'SSN');
      if (ssnType != null) {
        ssnType.lkpValueName = 'SSN';
      }
    }

    if (key === 'Service_Type' || key === 'Service_Type_IP' || key === 'Service_Type_IC' || key === 'Service_Type_Vendor' || key === 'Service_Type_IP_IC') {
      // keep the service type other at the end of the list.
      lookupValues.sort((a, b) => {
        if (a.lkpValueName === 'Other') return 1;
        if (b.lkpValueName === 'Other') return -1;
        return a.lkpValueName.localeCompare(b.lkpValueName);
      });
    }

    if (key === 'Referral_Source') {
      // keep the referral source 'Other' at the end of the list.
      lookupValues.sort((a, b) => {
        if (a.lkpValueCode === 'OTHER') return 1;
        if (b.lkpValueCode === 'OTHER') return -1;
        return a.lkpValueName.localeCompare(b.lkpValueName);
      });
    }

    // if key is special accommodation, keep the other option at the end.
    if (key === 'Special_Accomdation') {
      lookupValues.sort((a, b) => {
        if (a.lkpValueCode === 'OTH') return 1;
        if (b.lkpValueCode === 'OTH') return -1;
        return a.lkpValueName.localeCompare(b.lkpValueName);
      });
    }

    if (key === 'consumer_invoice_denial') {
      lookupValues.sort((a, b) => {
        if (a.lkpValueName === 'Other') return 1;
        if (b.lkpValueName === 'Other') return -1;
        return a.lkpValueName.localeCompare(b.lkpValueName);
      });
    }

    if (key === 'License_Type' || key === 'License_Type_IP' || key === 'License_Type_IC' || key === 'License_Type_Vendor' || key === 'adjustment_reason'
      || key === 'Upload_Doc_Type' || key === 'License_Type_Employer' || key === 'License_Type_IF' || key === 'License_Type_AR' || key === 'License_Type_Referral' || key === 'License_Type_Auth' || key === 'license_type_file_triage') {
      lookupValues.sort((a, b) => {
        if (a.lkpValueName === 'Other') return 1;
        if (b.lkpValueName === 'Other') return -1;
        return a.lkpValueName.localeCompare(b.lkpValueName);
      });
    }

    if (key === 'timesheet_filter_serviceCode' || key === 'invoice_filter_serviceCode' || key === 'purchaseRequest_filter_serviceCode') {
      lookupValues.sort((a, b) => a.lkpValueCode.localeCompare(b.lkpValueCode, undefined, { numeric: true }));
    }

    return lookupValues;
  }

  getProviderTypeLookup() {
    const program = this.userService.getSelectedProgram();
    const program_code = program ? program.program_code : '';
    const url = formatUrl(ENDPOINTS.GET_PROGRAM_TYPES, { program_code });
    return this.http.get(url);
  }

  getProviderLookupValue() {
    const providers = this.providerTypeLookupValues;
    return providers.responsedata.providerTypes;
  }

  getLookupName(lookupArr: LookupValueItem[], valueCode: string): string | undefined {
    const lookup = lookupArr.find((gen) => {
      return gen.lkpValueCode === valueCode;
    });
    return lookup ? lookup.lkpValueName : undefined;
  }

  fetchTasLookupValues() {
    const program = this.userService.getSelectedProgram();
    const program_code = program?.program_code;

    const payload = {
      "programCode": program_code,
      "payloadData": {
        "lkpdomainname":
          ["ng_tas_modifier_detail",
            "ng_tas_servicecode_detail",
            "ng_pay_region",
            "ng_pay_region_county"
          ]
      }
    }
    return this.http.post(ENDPOINTS.GET_TAS_LOOKUP_VALUES, payload);

  };

  getTasLookupValue(key: string) {
    let lookupValues: any = [];
    const lookupResponse = this.tasLookupValues;
    const lookupDomains = lookupResponse?.responsedata;
    lookupValues = lookupDomains[key];

    // if (targetDomain) {
    //   lookupValues = [...targetDomain.lookupValue];
    // }
    return lookupValues;
  }

  getDiagnosisLookupValues() {
    const program = this.userService.getSelectedProgram();
    const programCode = program ? program.program_code : ''; // unlikely its null
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_DIAGNOSIS_LOOKUP_VALUES, { programCode });
    return this.http.get(url);
  }

  fetchAndStoreLookupValues() {
    this.fetchLookupValues().subscribe((lookupData) => {
      this.lookupValues = lookupData;
    });
  }

  fetchAndStoreTasLookupValues() {
    this.fetchTasLookupValues().subscribe((lookupData) => {
      this.tasLookupValues = lookupData;
    });
  }

  fetchAndStoreProviderTypeLookupValues() {
    this.getProviderTypeLookup().subscribe((lookupData) => {
      this.providerTypeLookupValues = lookupData;
    });
  }

  getOrgDataByType(programCode: string): Observable<{ fiEntries: any[]; mcoEntries: any[] }> {
    return this.getOrgData(programCode).pipe(
      map((data: any) => {
        if (data?.status !== 200 || !data?.responsedata) {
          return { fiEntries: [], mcoEntries: [] };
        }

        const entries = data.responsedata;

        // here in future we might neeed to write a code to make sure the entries are filtered based on state.
        return {
          // since we are using it for california only right now, mapping the FMS to FI and RC to MCO
          status: data.status,
          // if someone needs all org data, can use orgData property.
          orgData: data.responsedata,
          mcoEntries: entries.filter((x: any) => x.orgTypeLookup === 'RC').sort((item1: any, item2: any) => item1.orgId - item2.orgId),
          fiEntries: entries.filter((x: any) => x.orgTypeLookup === 'FMS').sort((item1: any, item2: any) => item1.orgId - item2.orgId),
        };
      })
    );
  }

  // marked private as this is not to be used directly.
  public getOrgData(program_code: string) {
    const url = formatUrl(ENDPOINTS.GET_ORG_DATA, { program_code });
    return this.http.get(url);
  }
}
